import { invokeApi } from "../../bl_libs/invokeApi";

export const EditProfileApi = async (id, data) => {
  const requestObj = {
    path: `api/coach/profile/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const GetProfileApi = async (id) => {
  const requestObj = {
    path: `api/coach/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const changePassword = async (data) => {
  const requestObj = {
    path: `api/coach/change_password_by_coach`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
